document.addEventListener('DOMContentLoaded', function() {
    var sidebar = document.getElementById('sidebar');
    var btn = sidebar.querySelector('.btn');
    var viewMoreLink = document.querySelector('.link');
    var body = document.querySelector('body');
    var overlay = document.getElementById('overlay');
    var more_teams = document.querySelector('.view-more-teams');

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      sidebar.classList.toggle('open');
      overlay.style.display = sidebar.classList.contains('open') ? 'block' : 'none';
      body.style.overflow = sidebar.classList.contains('open') ? 'hidden' : '';
    });
    if (more_teams.getAttribute('href') === '#') {
      more_teams.addEventListener('click', function(e) {
        e.preventDefault();
        sidebar.classList.toggle('open');
        overlay.style.display = sidebar.classList.contains('open') ? 'block' : 'none';
        body.style.overflow = sidebar.classList.contains('open') ? 'hidden' : '';
      });
    }
    
    if (viewMoreLink.getAttribute('href') === '#') {
      viewMoreLink.addEventListener('click', function(e) {
        e.preventDefault();
        sidebar.classList.toggle('open');
        overlay.style.display = sidebar.classList.contains('open') ? 'block' : 'none';
        body.style.overflow = sidebar.classList.contains('open') ? 'hidden' : '';
      });
    }

    // Added event listener for sidebar close
    sidebar.addEventListener('click', function(e) {
      if (e.target === sidebar) {
        sidebar.classList.remove('open');
        overlay.style.display = 'none';
        body.style.overflow = '';
      }
    });

    // Added event listener for overlay click to close sidebar
    overlay.addEventListener('click', function() {
      sidebar.classList.remove('open');
      overlay.style.display = 'none';
      body.style.overflow = '';
    });

    // Added event listener for 'esc' key to close sidebar
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        if (sidebar.classList.contains('open')) {
          sidebar.classList.remove('open');
          overlay.style.display = 'none';
          body.style.overflow = '';
        }
      }
    });
  }); 